import { createSelector } from '@reduxjs/toolkit';
import { currentOpenChatIDSelector } from '../currentOpenChatIDSelector';
import { hostTypeSelector } from '../hostTypeSelector';
import { EHostType } from '../../types/hostType';
import { BLOB_ID } from '../../constants/blobId';

export const selectIsNewChatFromLinkOpened = createSelector(
  [currentOpenChatIDSelector, hostTypeSelector],
  (currentOpenChatId, hostType) =>
    /**
     * Условие истинно только в случае, если открыли новый чат по ссылке /new-chat/.
     * Открытие нового чата на хосте page сейчас невозможно.
     */
    hostType === EHostType.Page && currentOpenChatId === BLOB_ID,
);
